<template>
    <div>
        <ModalBase :show-modal="showModal" @close-modal="close" class="cost-modal">
            <template v-slot:titlebar>
                <TitleBar variant-class="title-modal">
                    <template v-slot:pretitle>
                        {{ $gettext('EDIT') }}
                    </template>
                    <template v-slot:title>
                        {{ $gettext('Cost') }} {{ costNumber }}
                    </template>
                </TitleBar>
            </template>
            <template v-slot:maincontent>
                <EditCost @edited="costEdited"/>
            </template>
            <template v-slot:premiumtip>
                <GekkoButton 
                    icon="fa-solid fa-circle-question"
                    variant="link"
                    size="lg"
                    class="close-btn text-unassigned"
                    style="right:1rem;"
                    id="tt-premium-tip"
                />
                <b-tooltip :custom-class="'tooltip-padded'" target="tt-premium-tip" placement="bottom" triggers="hover">
                    <div class="tooltip-title">
                        {{ $gettext('Premium Tip') }}
                    </div>
                    <div class="tooltip-text">
                        {{ premiumTipText }}
                    </div>
                </b-tooltip>
            </template>
        </ModalBase>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import EditCost from "@/components/costs/EditCost";
import ModalBase from "@/components/base_components/ModalBase";
import GekkoButton from "@/components/GekkoButton"

export default {
    name: "CostEditModal",
    props: {
        showModalOn: {
            type: Array
        },
    },
    components: { ModalBase, TitleBar, EditCost, GekkoButton },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                this.showModal = this.showModalOn.includes(to.name);
                (this.showModal) ? document.body.classList.add('modal-on') : document.body.classList.remove('modal-on');
            }
        },
    },
    data() {
        return {
            showModal: false,
            premiumTipText: this.$gettext("You can also add costs through email by forwarding your receipt from your account email to upload@costs.getgekko.com"),
        }
    },
    created() {
        window.addEventListener('keydown', this.closeEventListener);
    },
    destroyed() {
        window.removeEventListener('keydown', this.closeEventListener);
    },
    methods: {
        closeEventListener(event) {
            if (event.key === 'Escape') {
                this.$router.push({name: 'BalanceSheet'});
            }
        },
        close() {
            this.$router.push({name: 'BalanceSheet'});
            this.$emit('cancel');
        },
        costEdited(value) {
            this.$emit('edited', value);
            this.$router.push({name: 'BalanceSheet'});
        }
    },
    computed: {
        costNumber() {
            return this.$store.getters['costStore/getCostNumber'];
        },
        cost() {
            return this.$store.getters['costStore/getCostToEdit'];
        }
    }

}
</script>

<style scoped>

</style>